import React, { useEffect, useRef, useState } from "react";
import { Controller, useFieldArray, useForm } from "react-hook-form";
// import { Controller, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router";
import InputField from "../inputField/InputField";
import Strings from "../../res/String";
import PopUpModal from "../popupmodal/PopUpModal";
import Images from "../../assets";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { useSelector } from "react-redux";
import Dropdown from "react-multilevel-dropdown";

// Fetch user details

export const fetchCustomerNames = async () => {
  return await axios.get(`${process.env.REACT_APP_HOST}/customers`);
  // return await axios.get(`${process.env.REACT_APP_HOST}/customers/names`);
};

export default function NewPackingList(props) {
  const { control, handleSubmit, watch, setValue, getValues } = useForm({
    defaultValues: {
      newTeakRounds: [
        { length: "", girth: "", cbm: "", modifyGirth: "", modifyCbm: "" },
      ],
      newTeakSwan: [
        {
          width: "",
          thickness: "",
          length: "",
          noOfPieces: "",
          cbm: "",
        },
      ],
      item: "TEAK ROUND LOGS",
      totalTeakNos: "0",
      totalTeakCbm: "0.00",
      newValue: 0,
      averageModifyGirth: 0,
      modifyTotalCBM: 0,
      girthAction: "PLUS",
      editModifySwitch: false,
      partyName: "",
      cbm: 0,
      mtsNewValue: null,
    },
  });

  const {
    fields: userFields,
    append: appendUser,
    remove: removeUser,
    replace: replaceUser,
  } = useFieldArray({
    control,
    name: "newTeakRounds",
  });

  const {
    fields: teakFields,
    append: appendTeak,
    remove: removeTeak,
    replace: replaceTeak,
  } = useFieldArray({
    control,
    name: "newTeakSwan",
  });

  const navigate = useNavigate();
  const { state } = useLocation();

  const values = useSelector((state) => state?.loginData);

  const [isPopupOpen, setPopupOpen] = useState(false);
  const [showModifyGirth, setShowModifyGirth] = useState(false);

  const formData = watch();

  console.log("state", state);
  // SET VALUE FOR STATE
  useEffect(() => {
    if (state && state?.id) {
      setValue("fileId", state?.fileId);
      setValue("date", state?.date);
      setValue("agentName", state?.agentName);
      setValue("partyName", state?.partyName);
      setValue("pkl", state?.pkl);
      setValue("cbm", state?.cbm);
      setValue("comm", state?.comm);
      setValue("load", state?.loadvalue);
      setValue("received", state?.received);
      setValue("paidAmount", state?.paidAmount);
      setValue("balanceAmount", state?.balanceAmount);
      setValue("rate", state?.rate);
      setValue("mts", state?.mts);
      setValue("container", state?.container);
      setValue("lorry", state?.lorry);
      setValue("distance", state?.distance);
      setValue("shipTo", state?.shipTo);
      setValue("pincode", state?.pincode);
      setValue("fromName", state?.fromName);
      setValue("fromMobileNumber", state?.fromMobileNumber);
      setValue("fromStreet", state?.fromStreet);
      setValue("fromLandmark", state?.fromLandmark);
      setValue("fromCity", state?.fromCity);
      setValue("fromDistrict", state?.fromDistrict);
      setValue("fromPincode", state?.fromPincode);
      setValue("toName", state?.toName);
      setValue("toMobileNumber", state?.toMobileNumber);
      setValue("toStreet", state?.toStreet);
      setValue("toLandmark", state?.toLandmark);
      setValue("toCity", state?.toCity);
      setValue("toDistrict", state?.toDistrict);
      setValue("toPincode", state?.toPincode);
      setValue("gstNumber", state?.gstNumber);
      setValue("avgLength", state?.avgLength);
      setValue("avgGirth", state?.avgGirth);
      setValue("totalCbm", state?.totalCbm);
      setValue("totalNos", state?.totalNos);
      setValue("avgCft", state?.avgCft);
      setValue("swanNos", state?.swanNos);
      setValue("swanCbm", state?.swanCbm);
      setValue("totalTeakNos", state?.totalTeakNos);
      setValue("totalTeakCbm", state?.totalTeakCbm);
      setValue("amount", state?.amount);
      setValue("sumMTS", state?.sumMTS);
      setValue("invCBM", state?.invCBM);
      setValue("invRate", state?.invRate);
      setValue("item", state?.item);
      setValue("invAmount", state?.invAmount);
      setValue("plusGst", state?.plusGst);
      setValue("modifyTotalCBM", state?.modifyTotalCBM);
      setValue("averageModifyGirth", state?.averageModifyGirth);
      setValue("girthAction", state?.girthAction);
      setValue("newValue", state?.newValue);
      setValue("editModifySwitch", state?.editModifySwitch);
      setValue("mtsNewValue", state?.mtsNewValue);

      if (state?.newTeakRounds?.length > 0) {
        replaceUser(
          state?.newTeakRounds?.map((item) => ({
            length: item?.length || "",
            girth: item.girth || "",
            cbm: item.cbm || "",
            modifyGirth: item.modifyGirth || "",
            modifyCbm: item.modifyCbm || "",
          }))
        );
      }
      if (state?.newTeakSwan?.length > 0) {
        replaceTeak(
          state?.newTeakSwan?.map((item) => ({
            width: item?.width || "",
            thickness: item?.thickness || "",
            length: item?.length || "",
            noOfPieces: item?.noOfPieces || "",
            cbm: item?.cbm || "",
          }))
        );
      }
    } else {
      const savedFormData = localStorage.getItem("formData"); // Get saved data
      if (savedFormData) {
        const parsedData = JSON.parse(savedFormData); // Parse the saved data
        Object.keys(parsedData)?.forEach((fieldName) => {
          setValue(fieldName, parsedData[fieldName]); // Restore each field
        });
      }
      setValue("partyName", "");
    }
  }, [state, setValue, replaceUser, replaceTeak]);
  // SETVALUE END

  // POST API INTEGRATION START
  const { mutate, isSuccess, reset, isLoading } = useMutation(
    async (postData) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_HOST}/packinglist/save`,
          postData
        );
        return response.data; // Return data if needed
      } catch (error) {
        console.error("Error in mutation function:", error);
        throw error; // Re-throw the error so that onError is triggered
      }
    },
    {
      onSuccess: () => {
        setPopupOpen(true);
        reset();
        console.log("User added successfully.");
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
      },
    }
  );
  // POST API END

  // PUT API
  const { mutate: UpdateAPI, isLoading: updateLoading } = useMutation(
    async (postdata) => {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_HOST}/packinglist/update/${
            state && state?.id
          }`,
          postdata
        );
        return response.data; // Return the response to the mutation
      } catch (error) {
        console.error("Error while updating data:", error);
        throw error; // Re-throw the error so that `onError` in useMutation is triggered
      }
    },
    {
      onSuccess: (val) => {
        console.log("Data updated successfully:", val);
        setPopupOpen(!isPopupOpen); // Close popup after success
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
      },
    }
  );
  // PUT API END

  // Step state (persisted in localStorage)
  // const [step, setStep] = useState(
  //   () => Number(localStorage.getItem("currentStep")) || 1
  // );

  const [step, setStep] = useState(() => {
    const storedStep = Number(localStorage.getItem("currentStep")) || 1;
    const role = values?.role;

    if (role == "limitedAdmin") {
      return 3;
    }

    return storedStep;
  });

  const togglePopup = () => {
    setPopupOpen(!isPopupOpen);
  };

  const [appendvalue, setAppendValue] = useState("TEAK ROUND LOGS");
  // const { load, received, paidAmount, comm, rate, mts } = watch();

  // Refs for length and girth fields
  const lengthRefs = useRef([]);
  const girthRefs = useRef([]);

  // Handle 'Enter' key press for moving focus between fields
  const handleKeyPress = (event, index, fieldType) => {
    if (event.key === "Enter") {
      event.preventDefault();

      // If in length field, move focus to girth field of the same row
      if (fieldType === "length") {
        girthRefs.current[index].focus();
      }

      // If in girth field, move focus to the length field of the next row or append a new row if last
      else if (fieldType === "girth") {
        if (index === userFields?.length - 1) {
          // If it's the last row, append a new row and focus on the new length input
          appendUser({
            length: "",
            girth: "",
            cbm: "",
            modifyGirth: "",
            modifyCbm: "",
          });
          setTimeout(() => {
            lengthRefs.current[index + 1].focus(); // Focus on new row's length input
          }, 0);
        } else {
          // Otherwise, move focus to the next row's length input
          lengthRefs.current[index + 1].focus();
        }
      }
    }
  };

  // Refs for each input field (Width, Thickness, Length, Pieces)
  const fieldRefs = useRef({
    width: [],
    thickness: [],
    length: [],
    noOfPieces: [],
  });

  // Handle 'Enter' key press to navigate between fields and append a new row if necessary
  const handleEnterKeyPress = (event, fieldType, index) => {
    if (event.key === "Enter") {
      event.preventDefault();

      switch (fieldType) {
        case "width":
          // Move to thickness of the same row
          fieldRefs.current.thickness[index].focus();
          break;

        case "thickness":
          // Move to length of the same row
          fieldRefs.current.length[index].focus();
          break;

        case "length":
          // Move to noOfPieces of the same row
          fieldRefs.current.noOfPieces[index].focus();
          break;

        case "noOfPieces":
          // If it's the last row, append a new row and move to the width of the new row
          if (index === teakFields?.length - 1) {
            appendTeak({
              width: "",
              thickness: "",
              length: "",
              noOfPieces: "",
              cbm: "",
            });
            setTimeout(() => {
              fieldRefs.current.width[index + 1].focus(); // Focus on new row's width input
            }, 0);
          } else {
            // Otherwise, move to the next row's width field
            fieldRefs.current.width[index + 1].focus();
          }
          break;

        default:
          break;
      }
    }
  };

  const newTeakRounds = watch("newTeakRounds") || [];

  const girthAction = watch("girthAction") || "PLUS";

  const newValue = watch("newValue");

  // CALCULATE TEAK ROUND LOGS START

  // Calculate CBM and update totals/averages
  // const calculateValues = () => {
  //   let totalLength = 0;
  //   let totalGirth = 0;
  //   let totalCbm = 0;
  //   let totalModifyGirth = 0;
  //   let totalModifyCbm = 0;

  //   newTeakRounds &&
  //     newTeakRounds?.forEach((item, index) => {
  //       const length = Number(item?.length) || 0;
  //       const girth = Number(item?.girth) || 0;

  //       const modifyGirth = Number(item?.modifyGirth) || 0;

  //       const cbm = length && girth ? (length * girth * girth) / 16000000 : 0;

  //       const modifyCbm = length && modifyGirth ? (length * modifyGirth * modifyGirth) / 16000000 : 0;

  //       setValue(`newTeakRounds.${index}.cbm`, Number(cbm).toFixed(3));

  //       totalLength += length;
  //       totalGirth += girth;

  //       if (showModifyGirth) {
  //         totalModifyGirth += modifyGirth;
  //         setValue(`newTeakRounds.${index}.modifyCbm`, Number(modifyCbm).toFixed(3));
  //       }

  //     });

  //   totalCbm =
  //     newTeakRounds &&
  //     newTeakRounds
  //       ?.reduce((total, item) => total + parseFloat(item?.cbm), 0)
  //       .toFixed(3);

  //   totalModifyCbm =
  //     newTeakRounds &&
  //     newTeakRounds
  //       ?.reduce((total, item) => total + parseFloat(item?.modifyCbm || 0), 0)
  //       .toFixed(3);

  //   const totalNos = newTeakRounds && newTeakRounds?.length;
  //   const avgLength =
  //     totalNos > 0 ? (totalLength / totalNos).toFixed(2) : "0.000";
  //   const avgGirth =
  //     totalNos > 0 ? (totalGirth / totalNos).toFixed(2) : "0.000";
  //   const avgCft =
  //     totalNos > 0 ? ((totalCbm * 35.315) / totalNos).toFixed(2) : "0.000";

  //   setValue("avgLength", Number(avgLength).toFixed(2) || null);
  //   setValue("avgGirth", Number(avgGirth).toFixed(2) || null);
  //   setValue("totalCbm", Number(totalCbm).toFixed(3) || null);
  //   setValue("avgCft", Number(avgCft).toFixed(2) || null);
  //   setValue("totalNos", Number(totalNos) || null);

  //   if (showModifyGirth) {
  //     setValue("averageModifyGirth", (totalModifyGirth / totalNos).toFixed(2));
  //     setValue("modifyTotalCBM", Number(totalModifyCbm).toFixed(3));
  //   }
  // };

  // useEffect(() => {
  //   calculateValues();
  // }, []);

  const calculateValues = () => {
    let totalLength = 0;
    let totalGirth = 0;
    let totalCbm = 0;
    let totalModifyGirth = 0;
    let totalModifyCbm = 0;

    newTeakRounds?.forEach((item, index) => {
      const length = Number(item?.length) || 0;
      const girth = Number(item?.girth) || 0;
      const cbm = length && girth ? (length * girth * girth) / 16000000 : 0;

      totalLength += length;
      totalGirth += girth;
      totalCbm += cbm;

      setValue(`newTeakRounds.${index}.cbm`, Number(cbm).toFixed(3));

      if (showModifyGirth) {
        const modifier = parseFloat(newValue) || 0;
        const modifyGirth =
          girthAction === "PLUS" ? girth + modifier : girth - modifier;

        const modifyCbm =
          length && modifyGirth
            ? (length * modifyGirth * modifyGirth) / 16000000
            : 0;

        totalModifyGirth += modifyGirth;
        totalModifyCbm += modifyCbm;

        setValue(
          `newTeakRounds.${index}.modifyGirth`,
          Number(modifyGirth).toFixed(2)
        );
        setValue(
          `newTeakRounds.${index}.modifyCbm`,
          Number(modifyCbm).toFixed(3)
        );
      }
    });

    const totalNos = newTeakRounds?.length || 0;
    const avgLength =
      totalNos > 0 ? (totalLength / totalNos).toFixed(2) : "0.00";
    const avgGirth = totalNos > 0 ? (totalGirth / totalNos).toFixed(2) : "0.00";
    const avgCft =
      totalNos > 0 ? ((totalCbm * 35.315) / totalNos).toFixed(2) : "0.00";

    setValue("avgLength", Number(avgLength) || null);
    setValue("avgGirth", Number(avgGirth) || null);
    setValue("totalCbm", Number(totalCbm).toFixed(3) || null);
    setValue("avgCft", Number(avgCft) || null);
    setValue("totalNos", Number(totalNos) || 0);

    if (showModifyGirth) {
      const avgModifyGirth =
        totalNos > 0 ? (totalModifyGirth / totalNos).toFixed(2) : "0.00";
      setValue("averageModifyGirth", Number(avgModifyGirth) || 0);
      setValue("modifyTotalCBM", Number(totalModifyCbm).toFixed(3) || null);
    }
  };

  useEffect(() => {
    calculateValues();
  }, [newTeakRounds, newValue, girthAction, showModifyGirth]);

  // Apply modifyGirth logic
  // useEffect(() => {
  //   const modifier = parseFloat(newValue) || 0;

  //   const updated = newTeakRounds?.map((item) => {
  //     const originalGirth = parseFloat(item?.girth) || 0;
  //     const cbm = parseFloat(item?.cbm) || 0;
  //     const modified = girthAction === 'PLUS' ? originalGirth + modifier : originalGirth - modifier;

  //     return {
  //       ...item,
  //       modifyGirth: modified.toFixed(2),
  //       modifyCbm: cbm.toFixed(3),
  //     };
  //   });

  //   updated.forEach((item, index) => {
  //     setValue(`newTeakRounds.${index}.modifyGirth`, item?.modifyGirth);
  //     setValue(`newTeakRounds.${index}.modifyCbm`, item?.modifyCbm);
  //   });

  //   calculateValues();
  // }, [newTeakRounds, girthAction, newValue, setValue]);

  // CALCULATE TEAK ROUND LOGS END

  // Calculation for account details
  const {
    load,
    received,
    paidAmount,
    comm,
    rate,
    mts,
    totalCbm,
    totalTeakCbm,
    modifyTotalCBM,
    mtsNewValue,
    cbm,
    sumMTS,
  } = watch();

  // Calculation For COMMISION

  useEffect(() => {
    // Use fallback value 0 if any of the fields are undefined, null, or not numbers
    const parsedTotalCbm = Number(totalCbm) || 0;
    const parsedModifyTotalCbm = Number(modifyTotalCBM) || 0;
    const parsedCbm = Number(cbm) || 0;

    // If cbm is 0 or less, skip the calculation
    if (parsedCbm === 0) {
      setValue("comm", "0.00");
      return;
    }

    const referenceCbm = Math.max(parsedTotalCbm, parsedModifyTotalCbm);
    const commission = parsedCbm * 35.315 * referenceCbm;

    setValue("comm", commission.toFixed(2));
  }, [setValue, totalCbm, modifyTotalCBM, cbm]);

  // mts calculation
  useEffect(() => {
    const total = Number(totalCbm || 0);
    const modified = Number(modifyTotalCBM || 0);
    const rateVal = Number(rate || 0);
    const sumMtsVal = Number(sumMTS || 0);

    if (
      mtsNewValue !== undefined &&
      mtsNewValue !== null &&
      mtsNewValue !== ""
    ) {
      if (rateVal > 0) {
        const calculatedMts = sumMtsVal / rateVal / 35.315;
        console.log("calculatedMts", calculatedMts);
        setValue("mts", calculatedMts.toFixed(3));
      } else {
        setValue("mts", 0); // Optional: Handle invalid rate
      }
    } else {
      if (total > modified) {
        const differenceMts = total - modified;
        console.log("diffrence", differenceMts);
        setValue("mts", differenceMts.toFixed(3));
      } else {
        setValue("mts", 0); // Optional: Reset if not greater
      }
    }
  }, [totalCbm, modifyTotalCBM, setValue, mtsNewValue, sumMTS, rate]);

  // Account details calculation
  useEffect(() => {
    const originalCbm = Number(totalCbm) || Number(totalTeakCbm) || 0;
    const modifiedCbm = Number(modifyTotalCBM) || 0;
    const finalCbm =
      modifiedCbm > originalCbm ? Number(modifiedCbm) : Number(originalCbm);

    const numRate = Number(rate) || 0;
    const hasMtsNewValue =
      mtsNewValue !== undefined && mtsNewValue !== null && mtsNewValue !== "";
    const numMts = Number(mts) || 0;
    // const numMts = hasMtsNewValue ? Number(mtsNewValue) :   0;
    const numLoad = Number(load) || 0;
    const numReceived = Number(received) || 0;
    const numPaidAmount = Number(paidAmount) || 0;
    const numComm = Number(comm) || 0;

    // ✅ MTS Sum Calculation
    let sumMts = 0;
    if (hasMtsNewValue) {
      sumMts = Number(mtsNewValue);
      setValue("sumMTS", sumMts.toFixed(2));
    } else {
      sumMts = Number(numMts) * 35.315 * Number(numRate);
      setValue("sumMTS", Number(sumMts).toFixed(2));
    }

    // ✅ Final calculations based on finalCbm
    const amount = Number(finalCbm) * 35.315 * Number(numRate);
    setValue("amount", Number(amount).toFixed(2));

    const invCbm = Number(finalCbm) - Number(numMts);
    setValue("invCBM", Number(invCbm).toFixed(3));

    const invAmount = Number(amount) - Number(sumMts) - Number(numLoad);
    setValue("invAmount", Number(invAmount).toFixed(2));

    const invRate = invCbm !== 0 ? Number(invAmount) / Number(invCbm) : 0;
    setValue("invRate", Number(invRate).toFixed(2));

    const balanceAmt = numLoad + sumMts - numComm - numReceived + numPaidAmount;
    setValue("balanceAmount", Number(balanceAmt).toFixed(2));
  }, [
    setValue,
    totalCbm,
    totalTeakCbm,
    modifyTotalCBM,
    load,
    received,
    paidAmount,
    comm,
    rate,
    mts,
    mtsNewValue,
  ]);

  // Save form data to localStorage
  const saveFormDataToLocalStorage = () => {
    const formData = watch();

    if (!state) {
      localStorage.setItem("formData", JSON.stringify(formData));
    }
  };

  // Watch the fields to get updated values dynamically
  const teakRoundFields = watch("newTeakSwan");

  const [aggregatedData, setAggregatedData] = useState([]); // To store sizes, nos, cbm dynamically

  // Function to calculate aggregated data dynamically
  const calculateAndUpdate = () => {
    const dataMap = {}; // To store unique size combinations

    // Iterate over all the fields (teakRoundFields)
    teakRoundFields?.forEach((item, index) => {
      const { width, thickness, noOfPieces, cbm, length } = item;

      // If length, width, thickness, and noOfPieces are available
      if (length && width && thickness && noOfPieces) {
        const swancbm =
          (Number(length) *
            Number(width) *
            Number(thickness) *
            Number(noOfPieces)) /
          144 /
          35.315;

        // Set the calculated CBM value to the form
        setValue(
          `newTeakSwan.${index}.cbm`,
          Number(swancbm).toFixed(3) || null
        );

        // Generate key for this size combination (width X thickness)
        const key = `${width}X${thickness}`;

        // Check if this size combination already exists in the map
        if (!dataMap[key]) {
          // Create a new entry if it doesn't exist
          dataMap[key] = {
            sizes: key,
            nos: parseFloat(noOfPieces) || 0,
            cbm: parseFloat(swancbm) || 0,
          };
        } else {
          // Sum up nos and cbm if the size already exists
          dataMap[key].nos += parseFloat(noOfPieces) || 0;
          dataMap[key].cbm += parseFloat(swancbm) || 0;
        }
      }
    });

    // Convert dataMap to an array (containing the aggregated data)
    const aggregated = Object.values(dataMap);
    setAggregatedData(aggregated); // Update aggregated data state

    //  Calculate total nos (ensure numbers are valid)
    const totalNos = aggregated?.reduce(
      (sum, item) => sum + (Number(item?.nos) || 0),
      0
    );
    setValue("totalTeakNos", totalNos || null);

    //  Calculate total CBM (avoid NaN issues)
    const totalTeaksCbm =
      teakRoundFields?.reduce(
        (sum, item) => sum + (parseFloat(item?.cbm) || 0),
        0
      ) || 0;

    setValue("totalTeakCbm", Number(totalTeaksCbm).toFixed(3) || 0);
  };

  // Trigger calculation dynamically whenever 'newTeakSwan' fields change
  useEffect(() => {
    calculateAndUpdate();
  }, [teakRoundFields]);

  // FORM SUBMISSION
  const onSubmit = (data) => {
    const formData = {
      // ...data,
      fileId: data?.fileId || null,
      date: data?.date || null,
      agentName: data?.agentName || null,
      partyName: data?.partyName || null,
      pkl: data?.pkl || null,
      cbm: data?.cbm || null,
      comm: data?.comm || null,
      loadvalue: data?.load || null,
      received: data?.received || null,
      paidAmount: data?.paidAmount || null,
      balanceAmount: data?.balanceAmount || null,
      rate: data?.rate || null,
      mts: data?.mts || null,
      container: data?.container || null,
      lorry: data?.lorry || null,
      distance: data?.distance || null,
      shipTo: data?.shipTo || null,
      pincode: data?.pincode || null,
      fromName: data?.fromName || null,
      fromMobileNumber: data?.fromMobileNumber || null,
      fromStreet: data?.fromStreet || null,
      fromLandmark: data?.fromLandmark || null,
      fromCity: data?.fromCity || null,
      fromDistrict: data?.fromDistrict || null,
      fromPincode: data?.fromPincode || null,
      toName: data?.toName || null,
      toMobileNumber: data?.toMobileNumber || null,
      toStreet: data?.toStreet || null,
      toLandmark: data?.toLandmark || null,
      toCity: data?.toCity || null,
      toDistrict: data?.toDistrict || null,
      toPincode: data?.toPincode || null,
      gstNumber: data?.gstNumber || null,
      item: data?.item || null,
      avgLength: data?.avgLength || null,
      avgGirth: data?.avgGirth || null,
      totalCbm: data?.totalCbm || null,
      totalNos: data?.totalNos || null,
      avgCft: data?.avgCft || null,
      swanSizes: data?.swanSizes || null,
      swanNos: data?.swanNos || null,
      swanCbm: data?.swanCbm || null,
      totalTeakNos: data?.totalTeakNos || null,
      totalTeakCbm: data?.totalTeakCbm || null,
      newTeakRounds: data?.newTeakRounds || null,
      newTeakSwan: data?.newTeakSwan || null,
      aggregatedSizes: aggregatedData || null,
      amount: data?.amount || null,
      sumMTS: data?.sumMTS || null,
      invCBM: data?.invCBM || null,
      invRate: data?.invRate || null,
      invAmount: data?.invAmount || null,
      plusGst: data?.plusGst || null,
      distance: data?.distance || null,
      modifyTotalCBM: data?.modifyTotalCBM || null,
      averageModifyGirth: data?.averageModifyGirth || null,
      girthAction: data?.girthAction || null,
      newValue: data?.newValue || null,
      mtsNewValue: data?.mtsNewValue || null,
      // editModifySwitch: data?.editModifySwitch || null,
    };
    if (state && state?.id != null) {
      UpdateAPI(formData);
    } else {
      mutate(formData);
    }

    localStorage.removeItem("formData");
    localStorage.removeItem("currentStep");
  };

  const goToNextStep = () => {
    saveFormDataToLocalStorage(); // Save current form data

    setStep((prevStep) => {
      const newStep = prevStep + 1;
      localStorage.setItem("currentStep", newStep); // Save step to localStorage
      return newStep;
    });
    if (props?.divref?.current) {
      props?.divref?.current.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const goToPreviousStep = () => {
    saveFormDataToLocalStorage();
    window.scrollTo({ top: 0, behavior: "smooth" });
    setStep((prevStep) => {
      const newStep = prevStep - 1;
      localStorage.setItem("currentStep", newStep); // Save step to localStorage
      return newStep;
    });
    if (props?.divref?.current) {
      props?.divref?.current.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const { item } = watch();

  const { partyName, fromName } = watch();

  const { data, isError } = useQuery("fetchCustomerNames", fetchCustomerNames, {
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    retry: 1,
    staleTime: 10000,
  });

  let customerNameList = data && data?.data;
  const foundCustomer = customerNameList?.find(
    (customer) => customer?.customerName === fromName
  );

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedShippingIndex, setSelectedShippingIndex] = useState(null);

  // Handle address selection
  const handleAddressSelect = (name, address) => {
    setSelectedCategory(name);
    setSelectedAddress(address);
  };

  useEffect(() => {
    if (selectedAddress || state?.id) {
      setValue("toName", selectedCategory || state?.toName);
      setValue(
        "toMobileNumber",
        selectedAddress?.shippingAddressDoorNo || state?.toMobileNumber
      );
      setValue(
        "toStreet",
        selectedAddress?.shippingAddressStreet || state?.toStreet
      );
      setValue(
        "toLandmark",
        selectedAddress?.shippingAddressLandMark || state?.toLandmark
      );
      setValue("toCity", selectedAddress?.shippingAddressCity || state?.toCity);
      setValue(
        "toDistrict",
        selectedAddress?.shippingAddressState || state?.toDistrict
      );
      setValue(
        "toPincode",
        selectedAddress?.shippingAddressPincode || state?.toPincode
      );
      setValue("distance", selectedAddress?.kiloMeter || state?.distance);
    } else {
      // Clear all fields when address is removed
      setValue("toName", "");
      setValue("toMobileNumber", "");
      setValue("toStreet", "");
      setValue("toLandmark", "");
      setValue("toCity", "");
      setValue("toDistrict", "");
      setValue("toPincode", "");
      setValue("distance", "");
    }
  }, [selectedAddress, selectedCategory, setValue, state]);

  const updateCustomerFields = (customer) => {
    const empty = "";

    setValue("fromName", customer?.customerName || empty);
    setValue("fromMobileNumber", customer?.doorNo || empty);
    setValue("fromStreet", customer?.street || empty);
    setValue("fromLandmark", customer?.landMark || empty);
    setValue("fromCity", customer?.city || empty);
    setValue("fromDistrict", customer?.district || empty);
    setValue("fromPincode", customer?.pincode || empty);
    setValue("gstNumber", customer?.gstNumber || empty);
  };

  // console.log("state", state);

  // SET DEFAULT THIRD PAGE AND SHOW MODIFIER WHEN CLICK MODIFIED GIRTH BUTTON
  useEffect(() => {
    const currentStep = localStorage.getItem("currentStep");

    if (currentStep === "3" && state?.girthAction !== null) {
      setShowModifyGirth(true);
    }
  }, [state?.girthAction]);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className="px-3 py-4">
        {/* {values?.role === "limitedAdmin" && step === 1 && goToNextStep()} */}

        {step === 1 && (
          <>
            <div className="dataEntryInputContainer py-2">
              <div className="packing-list-input-block">
                <label className="paking-list-label">{Strings.fieldId}</label>
                <div className="packing-list-input">
                  <Controller
                    control={control}
                    name="fileId"
                    render={(field) => (
                      <InputField
                        dataEntryInputField="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="F02"
                      />
                    )}
                  />
                </div>
              </div>
              <div className="packing-list-input-block">
                <label className="paking-list-label">{Strings.date}</label>
                <div className="packing-list-input">
                  <Controller
                    control={control}
                    name="date"
                    render={(field) => (
                      <InputField
                        dataEntryInputField="data-entry-input-field"
                        {...field}
                        type="date"
                        placeholder="DD/MM/YYYY"
                      />
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="dataEntryInputContainer py-2">
              <div className="packing-list-input-block">
                <label className="paking-list-label">{Strings.agentName}</label>
                <div className="packing-list-input">
                  <Controller
                    control={control}
                    name="agentName"
                    render={(field) => (
                      <InputField
                        dataEntryInputField="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="KOMMI"
                      />
                    )}
                  />
                </div>
              </div>
              <div className="packing-list-input-block">
                <label className="paking-list-label">{Strings.partyName}</label>
                <div className="packing-list-input">
                  {/* <Controller
                    control={control}
                    name="partyName"
                    render={(field) => (
                      <InputField
                        dataEntryInputField="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="ARW"
                      />
                    )}
                  /> */}
                  <Controller
                    control={control}
                    name="partyName"
                    defaultValue=""
                    render={({ field }) => (
                      <select
                        {...field}
                        className="data-entry-input-field"
                        onChange={(e) => {
                          const selectedValue = e.target.value;
                          field.onChange(selectedValue); // update form value

                          const matchedCustomer = customerNameList?.find(
                            (c) => c?.customerName === selectedValue
                          );

                          // Populate or clear related form fields
                          updateCustomerFields(matchedCustomer);
                        }}
                      >
                        <option value="">Select Customer</option>
                        {customerNameList?.map((customer, index) => (
                          <option key={index} value={customer?.customerName}>
                            {customer?.customerName}
                          </option>
                        ))}
                      </select>
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="dataEntryInputContainer py-2">
              <div className="packing-list-input-block">
                <label className="paking-list-label">{Strings.pkl}</label>
                <div className="packing-list-input">
                  <Controller
                    control={control}
                    name="pkl"
                    render={({ field }) => (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="number"
                        step="any"
                        placeholder="12"
                      />
                    )}
                  />
                </div>
              </div>
              <div className="packing-list-input-block">
                <label className="paking-list-label">{Strings.cmb}</label>
                <div className="packing-list-input">
                  <Controller
                    control={control}
                    name="cbm"
                    render={({ field }) => (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="number"
                        step="any"
                        placeholder="13.790"
                      />
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="dataEntryInputContainer py-2">
              <div className="packing-list-input-block">
                <label className="paking-list-label">{Strings.comm}</label>
                <div className="packing-list-input">
                  <Controller
                    control={control}
                    name="comm"
                    render={({ field }) => (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="number"
                        step="any"
                        placeholder="14745.00"
                        readOnly
                      />
                    )}
                  />
                </div>
              </div>
              <div className="packing-list-input-block">
                <label className="paking-list-label">{Strings.load}</label>
                <div className="packing-list-input d-flex align-items-center justify-content-between flex-wrap">
                  <div className="--list-modify-input">
                    <Controller
                      control={control}
                      name="load"
                      render={({ field }) => (
                        <input
                          className="data-entry-input-field"
                          {...field}
                          type="number"
                          step="any"
                          placeholder="100000.00"
                        />
                      )}
                    />
                  </div>
                  <label className="--list-modify-label">MTS AMT : </label>
                  <div className="--list-modify-input">
                    <Controller
                      control={control}
                      name="mtsNewValue"
                      render={({ field }) => (
                        <input
                          className="data-entry-input-field"
                          {...field}
                          type="number"
                          step="any"
                          placeholder="2"
                          readOnly={!!modifyTotalCBM}
                          title={modifyTotalCBM ? "Modify Girth Added" : ""}
                          style={{
                            cursor: modifyTotalCBM ? "not-allowed" : "auto",
                            backgroundColor: modifyTotalCBM
                              ? "#f5f5f5"
                              : "white",
                          }}
                        />
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="dataEntryInputContainer py-2">
              <div className="packing-list-input-block">
                <label className="paking-list-label">{Strings.received}</label>
                <div className="packing-list-input">
                  <Controller
                    control={control}
                    name="received"
                    render={({ field }) => (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="number"
                        step="any"
                        placeholder="85255.00"
                      />
                    )}
                  />
                </div>
              </div>
              <div className="packing-list-input-block">
                <label className="paking-list-label">
                  {Strings.paidAmount}
                </label>
                <div className="packing-list-input">
                  <Controller
                    control={control}
                    name="paidAmount"
                    render={({ field }) => (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="number"
                        step="any"
                        placeholder="85255.00"
                      />
                    )}
                  />
                </div>
              </div>
              {/* <div /> */}
            </div>
            <div className="dataEntryInputContainer py-2">
              <div className="packing-list-input-block">
                <label className="paking-list-label">
                  {Strings.BalanceAmount}
                </label>
                <div className="packing-list-input">
                  <Controller
                    control={control}
                    name="balanceAmount"
                    render={({ field }) => (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="number"
                        step="any"
                        placeholder="85255.00"
                        readOnly
                      />
                    )}
                  />
                </div>
              </div>
              <div className="packing-list-input-block">
                <label className="paking-list-label">{Strings.rate}</label>
                <div className="packing-list-input">
                  <Controller
                    control={control}
                    name="rate"
                    render={({ field }) => (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="number"
                        step="any"
                        placeholder="1191"
                      />
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="dataEntryInputContainer py-2">
              <div
                className="packing-list-input-block"
                style={{ visibility: "hidden" }}
              >
                <label className="paking-list-label">{Strings.mts}</label>
                <div className="packing-list-input">
                  <Controller
                    control={control}
                    name="mts"
                    render={({ field }) => (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="number"
                        step="any"
                        placeholder="2"
                      />
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="packingListInputContainer py-3 d-flex justify-content-center gap-2">
              {/* <button
                type="button"
                className="packing-list-back-btn"
                onClick={goToPreviousStep}
              >
                Back
              </button> */}

              <button
                type="button"
                className="packing-list-next-btn"
                onClick={goToNextStep}
              >
                Next
              </button>
            </div>
          </>
        )}
        {step === 2 && (
          <>
            <div className="dataEntryInputContainer py-2">
              <div className="packing-list-input-block">
                <label className="paking-list-label">CONTAINER NO :</label>
                <div className="packing-list-input">
                  <Controller
                    control={control}
                    name="container"
                    render={({ field }) => (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="F02"
                      />
                    )}
                  />
                </div>
              </div>
              <div className="packing-list-input-block">
                <label className="paking-list-label">{Strings.lorry}</label>
                <div className="packing-list-input">
                  <Controller
                    control={control}
                    name="lorry"
                    render={({ field }) => (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="1630"
                      />
                    )}
                  />
                </div>
              </div>
            </div>

            <h6 className="packing-list-sub-heading pt-2">BILL DETAILS</h6>

            <div className="dataEntryInputContainer py-1">
              <div className="data-entry-input-block --packinglist-input-block">
                <label className="data-entry-label --add-user-label">
                  {/* {Strings.fromname} */}
                  NAME
                </label>
                <div className="data-entry-input --add-user-input">
                  <Controller
                    control={control}
                    name="fromName"
                    render={({ field }) => (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="CUSTOMER NAME"
                      />
                    )}
                  />
                </div>
              </div>
              <div className="data-entry-input-block --packinglist-input-block">
                <label className="data-entry-label --add-user-label">
                  {Strings.number}
                </label>
                <div className="data-entry-input --add-user-input">
                  <Controller
                    control={control}
                    name="fromMobileNumber"
                    render={({ field }) => (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="No.7"
                      />
                    )}
                  />
                </div>
              </div>
              <div className="data-entry-input-block --packinglist-input-block">
                <label className="data-entry-label --add-user-label">
                  {Strings.street}
                </label>
                <div className="data-entry-input --add-user-input">
                  <Controller
                    control={control}
                    name="fromStreet"
                    render={({ field }) => (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="AYAPPAKAM ROAD"
                      />
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="dataEntryInputContainer py-1">
              <div className="data-entry-input-block --packinglist-input-block">
                <label className="data-entry-label --add-user-label">
                  LANDMARK
                </label>
                <div className="data-entry-input --add-user-input">
                  <Controller
                    control={control}
                    name="fromLandmark"
                    render={({ field }) => (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="MGR PURAM"
                      />
                    )}
                  />
                </div>
              </div>
              <div className="data-entry-input-block --packinglist-input-block">
                <label className="data-entry-label --add-user-label">
                  {Strings.city}
                </label>
                <div className="data-entry-input --add-user-input">
                  <Controller
                    control={control}
                    name="fromCity"
                    render={({ field }) => (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="TIRUVALLUR"
                      />
                    )}
                  />
                </div>
              </div>
              <div className="data-entry-input-block --packinglist-input-block">
                <label className="data-entry-label --add-user-label">
                  DISTRICT
                </label>
                <div className="data-entry-input --add-user-input">
                  <Controller
                    control={control}
                    name="fromDistrict"
                    render={({ field }) => (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="Chennai"
                      />
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="dataEntryInputContainer py-1">
              <div className="data-entry-input-block --packinglist-input-block">
                <label className="data-entry-label --add-user-label">
                  {Strings.pincodetwo}
                </label>
                <div className="data-entry-input --add-user-input">
                  <Controller
                    control={control}
                    name="fromPincode"
                    render={({ field }) => (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="600058"
                      />
                    )}
                  />
                </div>
              </div>
              <div className="data-entry-input-block --packinglist-input-block">
                <label className="data-entry-label --add-user-label">
                  {Strings.gstnumber}
                </label>
                <div className="data-entry-input --add-user-input">
                  <Controller
                    control={control}
                    name="gstNumber"
                    render={({ field }) => (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="33GRDPS9509A1ZS"
                      />
                    )}
                  />
                </div>
              </div>
            </div>

            <h6 className="packing-list-sub-heading pt-2">SHIPPING DETAILS</h6>
            <div className="d-flex my-1 px-3">
              {partyName && (
                <select
                  className="data-entry-input-field"
                  value={selectedShippingIndex ?? ""}
                  onChange={(e) => {
                    const index = e.target.value;

                    if (index === "") {
                      // Clear all fields if default option is selected
                      handleAddressSelect(null, null);
                      setSelectedShippingIndex(null);
                    } else {
                      const selectedAddress =
                        foundCustomer?.shippinglist?.[index];
                      handleAddressSelect(partyName, selectedAddress);
                      setSelectedShippingIndex(index);
                    }
                  }}
                >
                  <option value="">Shipping Details</option>
                  {foundCustomer?.shippinglist?.map((address, index) => (
                    <option key={index} value={index}>
                      {`${address?.shippingAddressMobNo}, ${address?.shippingAddressDistrict}`}
                    </option>
                  ))}
                </select>
              )}
            </div>

            <div className="dataEntryInputContainer py-1">
              <div className="data-entry-input-block --packinglist-input-block">
                <label className="data-entry-label --add-user-label">
                  {Strings.toname}
                </label>
                <div className="data-entry-input --add-user-input">
                  <Controller
                    control={control}
                    name="toName"
                    render={({ field }) => (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="SARAVANA PACKING WORKS"
                      />
                    )}
                  />
                </div>
              </div>
              <div className="data-entry-input-block --packinglist-input-block">
                <label className="data-entry-label --add-user-label">
                  {Strings.number}
                </label>
                <div className="data-entry-input --add-user-input">
                  <Controller
                    control={control}
                    name="toMobileNumber"
                    render={({ field }) => (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="tel"
                        placeholder="7010489434"
                      />
                    )}
                  />
                </div>
              </div>
              <div className="data-entry-input-block --packinglist-input-block">
                <label className="data-entry-label --add-user-label">
                  {Strings.street}
                </label>
                <div className="data-entry-input --add-user-input">
                  <Controller
                    control={control}
                    name="toStreet"
                    render={({ field }) => (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="AYAPPAKAM ROAD"
                      />
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="dataEntryInputContainer py-1">
              <div className="data-entry-input-block --packinglist-input-block">
                <label className="data-entry-label --add-user-label">
                  AREA
                </label>
                <div className="data-entry-input --add-user-input">
                  <Controller
                    control={control}
                    name="toLandmark"
                    render={({ field }) => (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="MGR PURAM"
                      />
                    )}
                  />
                </div>
              </div>
              <div className="data-entry-input-block --packinglist-input-block">
                <label className="data-entry-label --add-user-label">
                  {Strings.city}
                </label>
                <div className="data-entry-input --add-user-input">
                  <Controller
                    control={control}
                    name="toCity"
                    render={({ field }) => (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="TIRUVALLUR"
                      />
                    )}
                  />
                </div>
              </div>
              <div className="data-entry-input-block --packinglist-input-block">
                <label className="data-entry-label --add-user-label">
                  STATE
                </label>
                <div className="data-entry-input --add-user-input">
                  <Controller
                    control={control}
                    name="toDistrict"
                    render={({ field }) => (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="TAMILNADU"
                      />
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="dataEntryInputContainer py-1">
              <div className="data-entry-input-block --packinglist-input-block">
                <label className="data-entry-label --add-user-label">
                  {Strings.pincodetwo}
                </label>
                <div className="data-entry-input --add-user-input">
                  <Controller
                    control={control}
                    name="toPincode"
                    render={({ field }) => (
                      <input
                        className="data-entry-input-field"
                        {...field}
                        type="text"
                        placeholder="600058"
                      />
                    )}
                  />
                </div>
              </div>

              <div className="data-entry-input-block --packinglist-input-block">
                <label className="data-entry-label --add-user-label">
                  {Strings.dist}
                </label>
                <div className="data-entry-input --add-user-input">
                  <Controller
                    control={control}
                    name="distance"
                    render={({ field }) => (
                      <input
                        {...field}
                        className="data-entry-input-field"
                        type="number"
                        step="any"
                        placeholder="28"
                      />
                    )}
                  />
                </div>
              </div>
            </div>

            <div className="packingListInputContainer py-3 d-flex justify-content-center gap-2">
              {values?.role === "limitedAdmin" ? (
                <>
                  <button
                    type="button"
                    className="packing-list-next-btn"
                    onClick={goToNextStep}
                  >
                    Next
                  </button>
                </>
              ) : (
                <>
                  <button
                    type="button"
                    className="packing-list-back-btn"
                    onClick={goToPreviousStep}
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    className="packing-list-next-btn"
                    onClick={goToNextStep}
                  >
                    Next
                  </button>
                </>
              )}
            </div>
          </>
        )}
        {step === 3 && (
          <>
            <div className="packingListInputContainer d-flex align-items-end py-2">
              <div className="data-entry-input-block">
                <label className="data-entry-label --add-user-label">
                  {Strings.item}
                </label>
                <div className="data-entry-input --add-user-input">
                  <Controller
                    name="item"
                    control={control}
                    defaultValue="TEAK ROUND LOGS"
                    render={({ field }) => (
                      <select {...field} className="data-entry-input-field">
                        <option value="TEAK ROUND LOGS">TEAK ROUND LOGS</option>
                        <option value="TEAK SAWN SIZE">TEAK SAWN SIZE</option>
                      </select>
                    )}
                  />
                </div>
              </div>
              {/* {state?.id && values?.role === "superAdmin" && (
                <div className="data-entry-input-block d-flex justify-content-end px-3">
                  <button
                    className="Modify_btn"
                    type="button"
                    onClick={() => setShowModifyGirth((prev) => !prev)}
                  >
                    {showModifyGirth ? "HIDE MODIFY GIRTH" : "MODIFY GIRTH"}
                  </button>
                </div>
              )} */}
              {values?.role == "superAdmin" && (
                <div className="data-entry-input-block d-flex justify-content-end px-3">
                  <button
                    className="Modify_btn"
                    type="button"
                    onClick={() => {
                      if (!mtsNewValue) {
                        setShowModifyGirth((prev) => !prev);
                      }
                    }}
                    style={{
                      cursor: mtsNewValue ? "not-allowed" : "pointer",
                      opacity: mtsNewValue ? 0.6 : 1,
                      pointerEvents: mtsNewValue ? "none" : "auto", // disables all mouse events if mtsNewValue exists
                    }}
                  >
                    {showModifyGirth ? "HIDE MODIFY GIRTH" : "MODIFY GIRTH"}
                  </button>
                  {/* <button
                    type="button"
                    className="Modify_btn"
                    onClick={() => {
                      if (mtsNewValue || modifyTotalCBM || newValue) {
                        setValue("mtsNewValue", 0);
                        setValue("modifyTotalCBM", 0);
                        setValue("newValue", 0);
                      }
                    }}
                  >
                    RESET
                  </button> */}

                  <button
                    type="button"
                    title="double click to reset"
                    className="Modify_btn"
                    onClick={() => {
                      if (mtsNewValue || modifyTotalCBM || newValue) {
                        setValue("mtsNewValue", null);
                        setValue("modifyTotalCBM", null);
                        setValue("newValue", null);
                        setValue("averageModifyGirth", null);

                        // Reset each newTeakRounds item
                        newTeakRounds?.forEach((_, index) => {
                          setValue(`newTeakRounds.${index}.modifyGirth`, null);
                          setValue(`newTeakRounds.${index}.modifyCbm`, null);
                        });
                      }
                    }}
                  >
                    RESET
                  </button>
                </div>
              )}
            </div>
            <h6 className="packing-list-sub-heading py-3">
              {Strings?.packinglistentry}
            </h6>

            {item === "TEAK ROUND LOGS" && (
              <>
                <div className="packingListInputContainer py-2 gap-2">
                  <table style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td></td>
                        <td className="packinglist-append-label"></td>
                        <td className="packinglist-append-input"></td>
                        <td className="packinglist-append-label"></td>
                        <td className="packinglist-append-input"></td>
                        <td className="packinglist-append-label"></td>
                        <td className="packinglist-append-input"></td>
                        {showModifyGirth && (
                          <>
                            <td className="packinglist-append-label">
                              M-GIRTH
                            </td>
                            <td className="packinglist-append-input">
                              <Controller
                                name="girthAction"
                                control={control}
                                defaultValue="PLUS"
                                render={({ field }) => (
                                  <select
                                    {...field}
                                    className="data-entry-input-field"
                                  >
                                    <option value="PLUS">PLUS(+)</option>
                                    <option value="MINUS">MINUS(-)</option>
                                  </select>
                                )}
                              />
                            </td>
                            <td className="packinglist-append-label">
                              <Controller
                                name="newValue"
                                control={control}
                                defaultValue="0"
                                render={({ field }) => (
                                  <input
                                    {...field}
                                    type="number"
                                    placeholder="0"
                                    className="data-entry-input-field"
                                  />
                                )}
                              />
                            </td>
                          </>
                        )}

                        <td className="packinglist-append-input"></td>
                      </tr>
                      {userFields?.map((field, index) => (
                        <tr key={field?.id}>
                          <td className="serial-number">{index + 1}</td>

                          <td
                            className="packinglist-append-label --length_label"
                            title="LENGTH"
                          >
                            {/* LEN : */}
                          </td>
                          <td className="packinglist-append-input">
                            <Controller
                              name={`newTeakRounds.${index}.length`}
                              control={control}
                              render={({ field }) => (
                                <input
                                  {...field}
                                  type="number"
                                  placeholder="175"
                                  step="any"
                                  className="data-entry-input-field"
                                  // style={{ width: "120px" }}
                                  onChange={(e) => {
                                    field.onChange(e);
                                    calculateValues();
                                  }}
                                  onKeyPress={(e) =>
                                    handleKeyPress(e, index, "length")
                                  }
                                  ref={(el) => (lengthRefs.current[index] = el)} // Set ref for length input
                                />
                              )}
                            />
                          </td>

                          <td className="packinglist-append-label --girth_label">
                            {/* {Strings?.girth} */}
                          </td>
                          <td className="packinglist-append-input">
                            <Controller
                              name={`newTeakRounds.${index}.girth`}
                              control={control}
                              render={({ field }) => (
                                <input
                                  {...field}
                                  type="number"
                                  placeholder="77"
                                  className="data-entry-input-field"
                                  // style={{ width: "120px" }}
                                  step="any"
                                  onChange={(e) => {
                                    field.onChange(e);
                                    calculateValues();
                                  }}
                                  onKeyPress={(e) =>
                                    handleKeyPress(e, index, "girth")
                                  }
                                  ref={(el) => (girthRefs.current[index] = el)} // Set ref for girth input
                                />
                              )}
                            />
                          </td>

                          <td className="packinglist-append-label">
                            {Strings?.cmb}
                          </td>
                          <td className="packinglist-append-input">
                            <Controller
                              name={`newTeakRounds.${index}.cbm`}
                              control={control}
                              render={({ field }) => (
                                <input
                                  {...field}
                                  type="number"
                                  step="any"
                                  disabled
                                  readOnly
                                  className="data-entry-input-field"
                                  style={{
                                    // width: "120px",
                                    outline: "none",
                                    border: "none",
                                  }}
                                  placeholder="0.00"
                                />
                              )}
                            />
                          </td>

                          {showModifyGirth && (
                            <>
                              <td className="packinglist-append-label">
                                M-GIRTH
                              </td>
                              <td className="packinglist-append-input">
                                <Controller
                                  name={`newTeakRounds.${index}.modifyGirth`}
                                  control={control}
                                  render={({ field }) => (
                                    <input
                                      {...field}
                                      type="number"
                                      placeholder="77"
                                      className="data-entry-input-field"
                                      step="any"
                                      readOnly
                                      onChange={(e) => {
                                        field.onChange(e);
                                        calculateValues();
                                      }}
                                    />
                                    /*  <input
                                        {...field}
                                        type="number"
                                        placeholder="77"
                                        className="data-entry-input-field"
                                        step="any"
                                        readOnly
                                      />*/
                                  )}
                                />
                              </td>

                              <td className="packinglist-append-label">
                                M-CBM
                              </td>
                              <td className="packinglist-append-input">
                                <Controller
                                  name={`newTeakRounds.${index}.modifyCbm`}
                                  control={control}
                                  render={({ field }) => (
                                    <input
                                      {...field}
                                      type="number"
                                      step="any"
                                      disabled
                                      readOnly
                                      className="data-entry-input-field"
                                      style={{
                                        outline: "none",
                                        border: "none",
                                      }}
                                      placeholder="0.00"
                                    />
                                  )}
                                />
                              </td>
                            </>
                          )}

                          <td className="packinglist-append-input">
                            {index !== 0 && (
                              <button
                                type="button"
                                onClick={() => {
                                  removeUser(index);
                                }}
                                style={{ padding: "5px", border: "none" }}
                              >
                                X
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}

                      {/* Average Length, Girth, CBM, etc. */}
                      <tr>
                        <td></td>
                        <td
                          className="packinglist-append-label"
                          title="AVG LENGTH"
                        >
                          AVG LEN :
                        </td>
                        <td className="packinglist-append-input">
                          <Controller
                            name="avgLength"
                            control={control}
                            render={({ field }) => (
                              <input
                                {...field}
                                type="number"
                                step="any"
                                readOnly
                                className="data-entry-input-field"
                                style={{
                                  // width: "120px",
                                  outline: "none",
                                  border: "none",
                                }}
                                placeholder="0.00"
                              />
                            )}
                          />
                        </td>

                        <td className="packinglist-append-label">
                          {Strings.avggirth}
                        </td>
                        <td className="packinglist-append-input">
                          <Controller
                            name="avgGirth"
                            control={control}
                            render={({ field }) => (
                              <input
                                {...field}
                                type="number"
                                step="any"
                                readOnly
                                className="data-entry-input-field"
                                style={{
                                  // width: "120px",
                                  outline: "none",
                                  border: "none",
                                }}
                                placeholder="0.00"
                              />
                            )}
                          />
                        </td>

                        <td
                          className="packinglist-append-label"
                          title="TOTAL CBM"
                        >
                          {/* {Strings.totalcbm} */}
                          TOT.CBM
                        </td>
                        <td className="packinglist-append-input">
                          <Controller
                            name="totalCbm"
                            control={control}
                            render={({ field }) => (
                              <input
                                {...field}
                                type="number"
                                step="any"
                                readOnly
                                className="data-entry-input-field"
                                style={{
                                  // width: "120px",
                                  outline: "none",
                                  border: "none",
                                }}
                                placeholder="0.00"
                              />
                            )}
                          />
                        </td>
                        {showModifyGirth && (
                          <>
                            <td className="packinglist-append-label">
                              AVG M-GIRTH
                            </td>
                            <td className="packinglist-append-input">
                              <Controller
                                name="averageModifyGirth"
                                control={control}
                                render={({ field }) => (
                                  <input
                                    {...field}
                                    type="number"
                                    step="any"
                                    readOnly
                                    className="data-entry-input-field"
                                    style={{ outline: "none", border: "none" }}
                                    placeholder="0.00"
                                  />
                                )}
                              />
                            </td>

                            <td className="packinglist-append-label">
                              TOTAL M-CBM
                            </td>
                            <td className="packinglist-append-input">
                              <Controller
                                name="modifyTotalCBM"
                                control={control}
                                render={({ field }) => (
                                  <input
                                    {...field}
                                    type="number"
                                    step="any"
                                    readOnly
                                    className="data-entry-input-field"
                                    style={{ outline: "none", border: "none" }}
                                    placeholder="0.00"
                                  />
                                )}
                              />
                            </td>
                          </>
                        )}
                      </tr>

                      {/* Total Numbers and Avg CFT */}
                      <tr>
                        <td></td>
                        <td
                          className="packinglist-append-label"
                          title="TOTAL NOS"
                        >
                          T_NOS :
                        </td>
                        <td className="packinglist-append-input">
                          <Controller
                            name="totalNos"
                            control={control}
                            render={({ field }) => (
                              <input
                                {...field}
                                type="number"
                                step="any"
                                readOnly
                                className="data-entry-input-field"
                                style={{
                                  // width: "120px",
                                  outline: "none",
                                  border: "none",
                                }}
                                placeholder="0.00"
                              />
                            )}
                          />
                        </td>

                        <td className="packinglist-append-label">
                          {Strings.avgcft}
                        </td>
                        <td className="packinglist-append-input">
                          <Controller
                            name="avgCft"
                            control={control}
                            render={({ field }) => (
                              <input
                                {...field}
                                type="number"
                                step="any"
                                readOnly
                                className="data-entry-input-field"
                                style={{
                                  // width: "120px",
                                  outline: "none",
                                  border: "none",
                                }}
                                placeholder="0.00"
                              />
                            )}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </>
            )}

            {item === "TEAK SAWN SIZE" && (
              <>
                <div className="packingListInputContainer py-2 gap-2">
                  <table style={{ width: "100%" }}>
                    <tbody>
                      {teakFields?.map((field, index) => (
                        <tr key={field?.id}>
                          <td className="serial-number">{index + 1}</td>

                          <td className="packinglist-append-label">
                            {/* {Strings?.width} */}
                            WIDTH
                          </td>
                          <td className="packinglist-append-input">
                            <Controller
                              name={`newTeakSwan.${index}.width`}
                              control={control}
                              render={({ field }) => (
                                <input
                                  {...field}
                                  type="number"
                                  step="any"
                                  placeholder="77"
                                  className="data-entry-input-field"
                                  // style={{ width: "85px" }}
                                  onChange={(e) => {
                                    field.onChange(e);
                                    calculateAndUpdate();
                                  }}
                                  onKeyPress={(e) =>
                                    handleEnterKeyPress(e, "width", index)
                                  }
                                  ref={(el) =>
                                    (fieldRefs.current.width[index] = el)
                                  } // Set ref for width input
                                />
                              )}
                            />
                          </td>

                          <td className="packinglist-append-label">THICK</td>
                          <td className="packinglist-append-input">
                            <Controller
                              name={`newTeakSwan.${index}.thickness`}
                              control={control}
                              render={({ field }) => (
                                <input
                                  {...field}
                                  type="number"
                                  step="any"
                                  placeholder="77"
                                  className="data-entry-input-field"
                                  // style={{ width: "85px" }}
                                  onChange={(e) => {
                                    field.onChange(e);
                                    calculateAndUpdate();
                                  }}
                                  onKeyPress={(e) =>
                                    handleEnterKeyPress(e, "thickness", index)
                                  }
                                  ref={(el) =>
                                    (fieldRefs.current.thickness[index] = el)
                                  } // Set ref for thickness input
                                />
                              )}
                            />
                          </td>

                          <td className="packinglist-append-label">
                            {/* {Strings?.length} */}
                            LENGTH
                          </td>
                          <td className="packinglist-append-input">
                            <Controller
                              name={`newTeakSwan.${index}.length`}
                              control={control}
                              render={({ field }) => (
                                <input
                                  {...field}
                                  type="number"
                                  step="any"
                                  placeholder="77"
                                  className="data-entry-input-field"
                                  // style={{ width: "85px" }}
                                  onChange={(e) => {
                                    field.onChange(e);
                                    calculateAndUpdate();
                                  }}
                                  onKeyPress={(e) =>
                                    handleEnterKeyPress(e, "length", index)
                                  }
                                  ref={(el) =>
                                    (fieldRefs.current.length[index] = el)
                                  } // Set ref for length input
                                />
                              )}
                            />
                          </td>
                          <td className="packinglist-append-label">
                            {/* {Strings?.noofpieces} */}
                            PICS
                          </td>
                          <td className="packinglist-append-input">
                            <Controller
                              name={`newTeakSwan.${index}.noOfPieces`}
                              control={control}
                              render={({ field }) => (
                                <input
                                  {...field}
                                  type="number"
                                  step="any"
                                  placeholder="77"
                                  className="data-entry-input-field"
                                  // style={{ width: "85px" }}
                                  onChange={(e) => {
                                    field.onChange(e);
                                    calculateAndUpdate();
                                  }}
                                  onKeyPress={(e) =>
                                    handleEnterKeyPress(e, "noOfPieces", index)
                                  }
                                  ref={(el) =>
                                    (fieldRefs.current.noOfPieces[index] = el)
                                  } // Set ref for pieces input
                                />
                              )}
                            />
                          </td>
                          <td className="packinglist-append-label">
                            {/* {Strings?.cmb} */}
                            CBM
                          </td>
                          <td className="packinglist-append-input">
                            <Controller
                              name={`newTeakSwan.${index}.cbm`}
                              control={control}
                              render={({ field }) => (
                                <input
                                  {...field}
                                  type="number"
                                  step="any"
                                  readOnly
                                  className="data-entry-input-field"
                                  style={{
                                    // width: "85px",
                                    outline: "none",
                                    border: "none",
                                  }}
                                  placeholder="0.00"
                                />
                              )}
                            />
                          </td>

                          <td className="packinglist-append-input">
                            {index !== 0 && (
                              <button
                                type="button"
                                onClick={() => {
                                  removeTeak(index);
                                }}
                                style={{ padding: "5px", border: "none" }}
                              >
                                X
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}

                      {/* Average Length, Girth, CBM, etc. */}
                      {aggregatedData && aggregatedData?.length > 0 ? (
                        aggregatedData?.map((item, idx) => (
                          <>
                            <tr key={idx}>
                              <td></td>

                              <td className="packinglist-append-label">
                                SIZES
                              </td>
                              <td className="packinglist-append-input">
                                <input
                                  type="number"
                                  step="any"
                                  name="swanSizes"
                                  readOnly
                                  value={item?.sizes}
                                  className="data-entry-input-field"
                                  style={{
                                    // width: "85px",
                                    outline: "none",
                                    border: "none",
                                  }}
                                  placeholder="0.00"
                                />
                              </td>
                              <td className="packinglist-append-label">NOS</td>
                              <td className="packinglist-append-input">
                                <input
                                  type="number"
                                  step="any"
                                  name="swanNos"
                                  readOnly
                                  value={item?.nos}
                                  className="data-entry-input-field"
                                  style={{
                                    // width: "85px",
                                    outline: "none",
                                    border: "none",
                                  }}
                                  placeholder="0.00"
                                />
                              </td>

                              <td className="packinglist-append-label">
                                {Strings.cmb}
                              </td>
                              <td className="packinglist-append-input">
                                <input
                                  type="number"
                                  step="any"
                                  name="swanCbm"
                                  readOnly
                                  value={item?.cbm?.toFixed(3)}
                                  className="data-entry-input-field"
                                  style={{
                                    // width: "85px",
                                    outline: "none",
                                    border: "none",
                                  }}
                                  placeholder="0.00"
                                />
                              </td>
                            </tr>
                          </>
                        ))
                      ) : (
                        <>
                          <tr>
                            <td></td>
                            <td className="packinglist-append-label">SIZES</td>
                            <td className="packinglist-append-input text-center">
                              -
                            </td>
                            <td className="packinglist-append-label">NOS</td>
                            <td className="packinglist-append-input text-center">
                              -
                            </td>
                            <td className="packinglist-append-label">CBM</td>
                            <td className="packinglist-append-input text-center">
                              -
                            </td>
                          </tr>
                        </>
                      )}
                      <tr>
                        <td></td>

                        <td
                          colSpan="2"
                          className="packinglist-append-label"
                        ></td>

                        <td className="packinglist-append-label">TOT.NOS</td>
                        <td className="packinglist-append-input">
                          <Controller
                            name="totalTeakNos"
                            control={control}
                            render={({ field }) => (
                              <input
                                {...field}
                                type="number"
                                step="any"
                                readOnly
                                className="data-entry-input-field"
                                style={{
                                  // width: "85px",
                                  outline: "none",
                                  border: "none",
                                }}
                                placeholder="0.00"
                              />
                            )}
                          />
                        </td>

                        <td className="packinglist-append-label">TOT.CBM</td>
                        <td className="packinglist-append-input">
                          <Controller
                            name="totalTeakCbm"
                            control={control}
                            render={({ field }) => (
                              <input
                                {...field}
                                type="number"
                                step="any"
                                readOnly
                                className="data-entry-input-field"
                                style={{
                                  // width: "85px",
                                  outline: "none",
                                  border: "none",
                                }}
                                placeholder="0.00"
                              />
                            )}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </>
            )}

            <div className="packingListInputContainer py-3 d-flex justify-content-center gap-2">
              {values?.role === "limitedAdmin" ? (
                <>
                  <button type="submit" className="packing-list-next-btn">
                    {updateLoading ? (
                      <i class="fa fa-spinner fa-spin"></i>
                    ) : (
                      <>Submit</>
                    )}
                  </button>
                </>
              ) : (
                <>
                  <button
                    type="button"
                    className="packing-list-back-btn"
                    onClick={goToPreviousStep}
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    className="packing-list-next-btn"
                    onClick={goToNextStep}
                  >
                    Next
                  </button>
                </>
              )}
            </div>
          </>
        )}

        {step === 4 && (
          <>
            <h6 className="packing-list-sub-heading pt-1">ACCOUNT DETAILS</h6>
            <div className="row d-flex align-items-center py-2 px-2">
              <div className="col-2">
                <label className="packing-list-label">PKL :</label>
              </div>
              <div className="col-2 p-0">
                <input
                  className="data-entry-input-field"
                  value={(formData && formData?.pkl) || ""}
                  type="number"
                  step="any"
                  readOnly
                  style={{ border: "none", outline: "none" }}
                />
              </div>
              <div className="col-2">
                <label className="packing-list-label">PARTY/AGENT :</label>
              </div>
              <div className="col-2 p-0">
                <input
                  className="data-entry-input-field"
                  type="text"
                  value={`${(formData && formData?.partyName) || ""} / ${
                    (formData && formData?.agentName) || ""
                  }`}
                  readOnly
                  style={{ border: "none", outline: "none" }}
                />
              </div>
              <div className="col-2">
                <label className="packing-list-label">LORRY :</label>
              </div>
              <div className="col-2 p-0">
                {" "}
                <input
                  className="data-entry-input-field"
                  type="text"
                  readOnly
                  value={(formData && formData?.lorry) || ""}
                  style={{ border: "none", outline: "none" }}
                />
              </div>
            </div>
            <div className="row d-flex align-items-center py-2 px-2">
              <div className="col-2">
                <label className="packing-list-label">{Strings.shipto}</label>
              </div>
              <div className="col-6 p-0">
                {/* <input
  className="data-entry-input-field"
  value={`${formData?.toMobileNumber || ""}, ${
    formData?.toStreet || ""
  }, ${
    formData?.toLandmark || ""
  }, ${
    formData?.toCity || ""
  }, ${
    formData?.toDistrict || ""
  }, ${
    formData?.toPincode || ""
  }`}
  type="text"
  readOnly
  style={{ border: "none", outline: "none" }}
/> */}

                <input
                  className="data-entry-input-field"
                  value={[
                    formData?.toMobileNumber,
                    formData?.toStreet,
                    formData?.toLandmark,
                    formData?.toCity,
                    formData?.toDistrict,
                    formData?.toPincode,
                  ]
                    .filter(Boolean) // removes null, undefined, and empty string
                    .join(", ")}
                  type="text"
                  readOnly
                  style={{ border: "none", outline: "none" }}
                />
              </div>
            </div>
            <div className="row d-flex align-items-center py-2 px-2">
              <div className="col-2">
                <label className="packing-list-label">{Strings.cmb}</label>
              </div>
              <div className="col-2 p-0">
                {/* {formData &&
                  Number(formData?.totalCbm) !== 0 &&
                  Number(formData?.totalCbm) != null && (
                    <input
                      className="data-entry-input-field"
                      value={formData?.totalCbm || ""}
                      type="number"
                      step="any"
                      readOnly
                      style={{ border: "none", outline: "none" }}
                    />
                  )} */}

                {formData &&
                  Number(formData?.totalCbm) !== 0 &&
                  Number(formData?.totalCbm) != null && (
                    <input
                      className="data-entry-input-field"
                      value={
                        Number(formData?.modifyTotalCBM) >
                        Number(formData?.totalCbm)
                          ? formData?.modifyTotalCBM
                          : formData?.totalCbm || ""
                      }
                      type="number"
                      step="any"
                      readOnly
                      style={{ border: "none", outline: "none" }}
                    />
                  )}

                {formData &&
                  Number(formData?.totalTeakCbm) !== 0 &&
                  Number(formData?.totalTeakCbm) != null && (
                    <input
                      className="data-entry-input-field"
                      value={formData?.totalTeakCbm || ""}
                      type="number"
                      step="any"
                      readOnly
                      style={{ border: "none", outline: "none" }}
                    />
                  )}
              </div>
              <div className="col-2">
                <label className="packing-list-label">{Strings.rate}</label>
              </div>
              <div className="col-2 p-0">
                <input
                  className="data-entry-input-field"
                  value={(formData && formData?.rate) || ""}
                  type="number"
                  step="any"
                  readOnly
                  style={{ border: "none", outline: "none" }}
                />
              </div>
              <div className="col-2">
                <label className="packing-list-label">{Strings.amt}</label>
              </div>
              <div className="col-2 p-0">
                <Controller
                  control={control}
                  name="amount"
                  render={({ field }) => (
                    <input
                      className="data-entry-input-field"
                      {...field}
                      type="number"
                      step="any"
                      readOnly
                      style={{ border: "none", outline: "none" }}
                    />
                  )}
                />
              </div>
            </div>
            <div className="row d-flex align-items-center py-2 px-2">
              <div className="col-2">
                <label className="packing-list-label">{Strings.mts}</label>
              </div>
              <div className="col-2 p-0">
                <Controller
                  control={control}
                  name="mts"
                  render={({ field }) => (
                    <input
                      className="data-entry-input-field"
                      {...field}
                      type="number"
                      step="any"
                      readOnly
                      style={{ border: "none", outline: "none" }}
                    />
                  )}
                />
              </div>
              <div className="col-2"></div>
              <div className="col-2"></div>
              <div className="col-2">
                <label className="packing-list-label">MTS AMOUNT : </label>
              </div>
              <div className="col-2 p-0">
                <Controller
                  control={control}
                  name="sumMTS"
                  render={({ field }) => (
                    <input
                      className="data-entry-input-field"
                      {...field}
                      type="number"
                      step="any"
                      readOnly
                      style={{ border: "none", outline: "none" }}
                    />
                  )}
                />
              </div>
            </div>
            <div className="row d-flex align-items-center py-2 px-2">
              <div className="col-2">
                <label className="packing-list-label">DISCOUNT :</label>
              </div>
              <div className="col-2 p-0">
                <input
                  className="data-entry-input-field"
                  value={(formData && formData?.load) || ""}
                  type="number"
                  step="any"
                  readOnly
                  style={{ border: "none", outline: "none" }}
                />
              </div>
              <div className="col-2"></div>
              <div className="col-2"></div>
              <div className="col-2"></div>
              <div className="col-2 p-0">
                <input
                  className="data-entry-input-field"
                  value={(formData && formData?.load) || ""}
                  type="text"
                  readOnly
                  style={{ border: "none", outline: "none" }}
                />
              </div>
            </div>
            <div className="row d-flex align-items-center py-2 px-2">
              <div className="col-2">
                {" "}
                <label className="packing-list-label">INV CBM :</label>
              </div>
              <div className="col-2 p-0">
                <Controller
                  control={control}
                  name="invCBM"
                  render={({ field }) => (
                    <input
                      className="data-entry-input-field"
                      {...field}
                      type="number"
                      step="any"
                      readOnly
                      style={{ border: "none", outline: "none" }}
                    />
                  )}
                />
              </div>
              <div className="col-2">
                <label className="packing-list-label">INV RATE :</label>
              </div>
              <div className="col-2 p-0">
                <Controller
                  control={control}
                  name="invRate"
                  render={({ field }) => (
                    <input
                      className="data-entry-input-field"
                      {...field}
                      type="number"
                      step="any"
                      readOnly
                      style={{ border: "none", outline: "none" }}
                    />
                  )}
                />
              </div>
              <div className="col-2">
                <label className="packing-list-label">INV AMOUNT :</label>
              </div>
              <div className="col-2 p-0">
                <Controller
                  control={control}
                  name="invAmount"
                  render={({ field }) => (
                    <input
                      className="data-entry-input-field"
                      {...field}
                      type="number"
                      step="any"
                      readOnly
                      style={{ border: "none", outline: "none" }}
                    />
                  )}
                />
              </div>
            </div>
            <div className="row d-flex align-items-center py-2 px-2">
              <div className="col-2">
                <label className="packing-list-label">{Strings?.avgcft}</label>
              </div>
              <div className="col-2 p-0">
                <input
                  className="data-entry-input-field"
                  value={(formData && formData?.avgCft) || ""}
                  type="number"
                  step="any"
                  readOnly
                  style={{ border: "none", outline: "none" }}
                />
              </div>
              <div className="col-2">
                <label className="packing-list-label">NOS :</label>
              </div>
              <div className="col-2 p-0">
                {formData && formData?.totalNos > 1 && (
                  <>
                    <input
                      className="data-entry-input-field"
                      value={(formData && formData?.totalNos) || ""}
                      type="number"
                      step="any"
                      readOnly
                      style={{ border: "none", outline: "none" }}
                    />
                  </>
                )}
                {formData && formData?.totalTeakNos != null && (
                  <>
                    <input
                      className="data-entry-input-field"
                      value={(formData && formData?.totalTeakNos) || ""}
                      type="number"
                      step="any"
                      readOnly
                      style={{ border: "none", outline: "none" }}
                    />
                  </>
                )}
              </div>
              <div className="col-2">
                <label className="packing-list-label">PLUS GST :</label>
              </div>
              <div className="col-2 p-0">
                <Controller
                  control={control}
                  name="plusGst"
                  render={({ field }) => (
                    <input
                      className="data-entry-input-field"
                      {...field}
                      type="text"
                      // readOnly
                      style={{ border: "none", outline: "none" }}
                    />
                  )}
                />
              </div>
            </div>
            <div className="row d-flex align-items-center py-2 px-2">
              <div className="col-2">
                <label className="packing-list-label">DISTANCE :</label>
              </div>
              <div className="col-2 p-0">
                <input
                  className="data-entry-input-field"
                  value={(formData && formData?.distance) || ""}
                  type="number"
                  step="any"
                  readOnly
                  style={{ border: "none", outline: "none" }}
                />
              </div>
              <div className="col-2">
                <label className="packing-list-label">PARTY PIN-CODE :</label>
              </div>
              <div className="col-2 p-0">
                <input
                  className="data-entry-input-field"
                  value={(formData && formData?.fromPincode) || ""}
                  type="text"
                  readOnly
                  style={{ border: "none", outline: "none" }}
                />
              </div>
              <div className="col-2">
                <label className="packing-list-label">SHIP TO PIN-CODE :</label>
              </div>
              <div className="col-2 p-0">
                <input
                  className="data-entry-input-field"
                  value={(formData && formData?.toPincode) || ""}
                  type="text"
                  readOnly
                  style={{ border: "none", outline: "none" }}
                />
              </div>
            </div>
            <div className="packingListInputContainer py-3 d-flex justify-content-center gap-2">
              {step > 1 && (
                <button
                  type="button"
                  className="packing-list-back-btn"
                  onClick={goToPreviousStep}
                >
                  Back
                </button>
              )}
              {step === 4 && (
                <>
                  {/* <label
                    type="submit"
                    className="packing-list-back-btn"
                    onClick={downloadAcReport}
                  >
                    Download
                  </label> */}
                  <button type="submit" className="packing-list-next-btn">
                    {isLoading || updateLoading ? (
                      <i class="fa fa-spinner fa-spin"></i>
                    ) : (
                      <>Submit</>
                    )}
                  </button>
                </>
              )}
            </div>
          </>
        )}
      </form>
      <PopUpModal isOpen={isPopupOpen} onClose={togglePopup}>
        <div className="img-block">
          <div style={{ width: "40%", height: "60%" }} className="mx-2 pt-2">
            <img
              src={Images?.logo}
              style={{ width: "100%", height: "100%" }}
              alt=""
            />
          </div>
        </div>
        <div className="d-flex flex-column align-items-center justify-content-center py-2">
          {state && state?.id ? (
            <>
              <h6 className="popup-content mb-3">
                Packing List Has Been Updated Successfuly..
              </h6>
            </>
          ) : (
            <>
              <h6 className="popup-content mb-3">
                Packing List Has Been Added Successfuly..
              </h6>
            </>
          )}
          {(values?.role == "superAdmin" || values?.role == "admin") && (
            <>
              <button
                className="user-add-button mt-2 mb-2"
                onClick={() => {
                  navigate("/agentManagement");
                  window.location.reload();
                }}
              >
                OK
              </button>
            </>
          )}
          {values?.role == "limitedAdmin" && (
            <>
              <button
                className="user-add-button mt-2 mb-2"
                onClick={() => {
                  navigate("/");
                  window.location.reload();
                }}
              >
                OK
              </button>
            </>
          )}
        </div>
      </PopUpModal>
    </>
  );
}
